import * as ko from "knockout";
import {IMessageData, ISyncField} from "../../../index";
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {lm, lm_} from "../../../appContext";
import {getSourceTranslation} from "../../../util/misc";
import {IComboboxOptions_syncfield} from "../../combobox/syncfield";
import smsfieldHtml from './smsfield.html?raw';

export let template: string = smsfieldHtml;

interface IParams {
    fields: KnockoutObservable<string>
}

export class viewModel {

    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    readonly selectedSyncfields: KnockoutObservableArray<ISyncField> = ko.observableArray()
    readonly selectedSyncfieldStrings: KnockoutComputed<string[]> = ko.pureComputed(() => {
        return this.selectedSyncfields().map(sf => getSourceTranslation(sf))
    })
    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();

    constructor(params: IParams) {
        const fieldNames = params.fields() ? params.fields().split(',') : [];
        const syncfields = lm_.User.translations().filter(sf => fieldNames.includes(sf.name))
        this.selectedSyncfields(syncfields);
        this.kosub.subscribe(this.selectedSyncfields, () => {
            params.fields(this.selectedSyncfields().map(sf => sf.name).join(','));
        });
    }

    getComboboxParams(): IComboboxOptions_syncfield {
        return {
            comboboxOptions: {
                inputAttrs: {placeholder: lm.t('add subject|s:((synchronization field|ac))')},
                option: {
                    constrain: sf => {
                        return !this.selectedSyncfields()
                            .map(sf => sf?.syncfieldid)
                            .includes(sf?.syncfieldid)
                    },
                },
                data: lm_.User.translations(),
                selectionMode: 'pick',
                onSelect: sf => {
                    if (sf) {
                        this.selectedSyncfields.push(sf)
                    }
                },
            },
        }
    }

    remove(sf: ISyncField) {
        this.selectedSyncfields.remove(sf);
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }

}
